<onafriq-modal>
  <div
    class="bg-white md:h-[191px] md:w-[1100px] w-[95%] h-fit rounded-2xl p-7.5 fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
    style="box-shadow: 0px 4px 28px 0px rgba(0, 47, 56, 0.25)">
    <h2 class="text-gray-900 text-h3">Please select filters</h2>
    <div class="mt-2 flex gap-4">
      <onafriq-dropdown
        #productsDropdown
        *ngIf="forceRerenderProductDropdown"
        [label]="'Product'"
        (onItemSelect)="addProducts($event)"
        [hasSearch]="true"
        (onSearchChange)="onProductsSearch($event)"
        [placeholder]="selectedProductsList.size > 0 ? selectedProductsList.size + ' Selected' : 'Select'"
        [dropdownMenu]="productsList"
        class="min-w-50"
        [isMultiSelect]="false" />
      <onafriq-dropdown
        #directionsDropdown
        *ngIf="forceRerenderDirectionDropdown"
        [label]="'Direction'"
        (onItemSelect)="addDirections($event)"
        [placeholder]="selectedDirection"
        [dropdownMenu]="directionList"
        [isMultiSelect]="false"
        class="min-w-50"
        [hasSearch]="false" />
      <onafriq-dropdown
        *ngIf="forceRerenderPartnerDropdown"
        #partnersDropdown
        [label]="'Partner'"
        (onItemSelect)="selectPartner($event)"
        [placeholder]="PartnerNames"
        [dropdownMenu]="options || []"
        [disabled]="!enablePartnerDropdown"
        [isMultiSelect]="false"
        class="min-w-50"
        [hasSearch]="true"
        (onSearchChange)="onPartnersSearch($event)"></onafriq-dropdown>
      <papi-custom-dropdown
        *ngIf="forceRerenderCountryDropdown"
        #partnerDropdown2
        [label]="'Country'"
        [placeholder]="CountryNames"
        [disabled]="!enableCountriesDropdown"
        [dropdownMenu]="cntry"
        [isMultiSelect]="false"
        [hasSearch]="true"
        class="min-w-50">
        <div class="mt-1 mb-0.5 relative">
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="absolute top-[30%] left-0 ml-[15px]">
            <g clip-path="url(#clip0_3404_11328)">
              <path
                d="M10.5 10.5L8.75005 8.75M10 5.75C10 8.09721 8.09721 10 5.75 10C3.40279 10 1.5 8.09721 1.5 5.75C1.5 3.40279 3.40279 1.5 5.75 1.5C8.09721 1.5 10 3.40279 10 5.75Z"
                stroke="#242729"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </g>
            <defs>
              <clipPath id="clip0_3404_11328">
                <rect width="12" height="12" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <input
            autocomplete="off"
            name="searchInput"
            placeholder="Search"
            [(ngModel)]="searcheCountryName"
            (input)="onCountriesSearch($event)"
            type="text"
            class="border-gray-300 pl-8 placeholder-gray-300 font-radikal-light border-b py-2 text-sm text-gray-600 px-2 w-full focus:outline-none focus:border-yellow-800" />
        </div>
        <div
          class="py-2.5 flex items-center hover:bg-primary-200 px-2 gap-2 cursor-pointer border-b"
          *ngFor="let item of filteredCountries?.length ? filteredCountries : cntry"
          (click)="selectCountry(item, partnerDropdown2)">
          <span class="text-gray-600 font-radikal-light text-sm leading-4 cursor-pointer">
            {{ item.countryname }}
          </span>
        </div>
        <div *ngIf="filteredCountries?.length === 0" class="text-sm p-2 text-gray-800">No matching countries found</div>
      </papi-custom-dropdown>
    </div>

    <!-- show selected value from filter dropdown -->
    <div
      class="flex mb-2 mt-2"
      *ngIf="
        selectedPartners.size === 0 &&
        selectedProductsList.size === 0 &&
        selectedDirection === 'Select' &&
        selectedCountries.size === 0
      ">
      <span class="showing-result-for">No filter Selected </span>
    </div>
    <div class="flex items-center gap-2 mt-4">
      <div
        *ngIf="
          selectedPartners.size > 0 ||
          selectedProductsList.size > 0 ||
          selectedDirection !== 'Select' ||
          selectedCountries.size > 0
        ">
        Selected :
      </div>
      <div
        class="flex flex-wrap items-center gap-2"
        *ngIf="
          selectedPartners.size > 0 ||
          selectedProductsList.size > 0 ||
          selectedDirection !== 'Select' ||
          selectedCountries.size > 0
        ">
        <div
          class="border-gray-800 border text-sm flex items-center w-max px-2 gap-1 pt-0.5 rounded-md"
          *ngFor="let partner of selectedPartners"
          name="partner.orgname">
          {{ partner.orgname }}
          <onafriq-icon [icon]="'cancel'" [color]="'gray-800'" [size]="'sm'" (click)="removePartner(partner)" />
        </div>
        <div
          class="border-gray-800 border text-sm flex items-center w-max px-2 gap-1 pt-0.5 rounded-md"
          *ngFor="let cntry of selectedCountries"
          name="cntry.countryname">
          {{ cntry.countryname }}
          <onafriq-icon [icon]="'cancel'" [color]="'gray-800'" [size]="'xs'" (click)="removeCountry(cntry)" />
        </div>
        <div
          class="border-gray-800 border text-sm flex items-center w-max px-2 gap-1 pt-0.5 rounded-md"
          *ngFor="let product of selectedProductsList">
          {{ product }}
          <onafriq-icon [icon]="'cancel'" [color]="'gray-800'" [size]="'xs'" (click)="removeProduct(product)" />
        </div>
        <span *ngIf="selectedDirection != 'Select'">
          <div class="border-gray-800 border text-sm flex items-center w-max px-2 gap-1 pt-0.5 rounded-md">
            {{ selectedDirection }}
            <onafriq-icon
              [icon]="'cancel'"
              [color]="'gray-800'"
              [size]="'xs'"
              (click)="removeDirection()" />
          </div>
        </span>
      </div>
    </div>
    <div class="mt-6 flex gap-4 justify-end items-center">
      <div class="text-sm text-gray-800 cursor-pointer mt-1" (click)="closeModal.emit()">Cancel</div>
      <onafriq-button type="secondary" label="Reset" (onClick)="resetTable()" />
      <onafriq-button label="Apply Filters" (onClick)="applyFilter()" />
    </div>
  </div>
</onafriq-modal>
